module.exports = __webpack_public_path__ + "img/38.c4140db5.jpeg";